import { AppState } from "@/mk2/reducers";

import {
    CommonPlaceTopicsPageState,
    SearchState,
    initialCommonPlaceTopicsPageState,
    initialSearchState,
} from "./CommonPlaceTopics.reducers";

export const getForumTopicsState = (state: AppState): CommonPlaceTopicsPageState =>
    state.containers.forum.commonPlaceTopics || initialCommonPlaceTopicsPageState;

export const getForumTopicsSearchState = (
    state: AppState,
    placeType: string,
    search: string,
): SearchState => {
    const topicsState = getForumTopicsState(state);
    return topicsState.types[placeType] && topicsState.types[placeType][search]
        ? topicsState.types[placeType][search]
        : initialSearchState;
};
